"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeObjectFromMemory = void 0;
function freeObjectFromMemory(object, domReference) {
    object.traverse((obj) => {
        if (obj.material) {
            obj.material.isMaterial ?
                removeMaterial(obj.material) :
                obj.material.forEach((material) => removeMaterial(material));
        }
        if (obj.geometry) {
            removeGeometry(obj.geometry);
        }
        if (obj.texture) {
            removeTexture(obj.texture);
        }
    });
}
exports.freeObjectFromMemory = freeObjectFromMemory;
function removeMaterial(material) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    material.dispose();
    (_a = material.map) === null || _a === void 0 ? void 0 : _a.dispose();
    (_b = material.lightMap) === null || _b === void 0 ? void 0 : _b.dispose();
    (_c = material.aoMap) === null || _c === void 0 ? void 0 : _c.dispose();
    (_d = material.emissiveMap) === null || _d === void 0 ? void 0 : _d.dispose();
    (_e = material.bumpMap) === null || _e === void 0 ? void 0 : _e.dispose();
    (_f = material.normalMap) === null || _f === void 0 ? void 0 : _f.dispose();
    (_g = material.displacementMap) === null || _g === void 0 ? void 0 : _g.dispose();
    (_h = material.roughnessMap) === null || _h === void 0 ? void 0 : _h.dispose();
    (_j = material.metalnessMap) === null || _j === void 0 ? void 0 : _j.dispose();
    (_k = material.alphaMap) === null || _k === void 0 ? void 0 : _k.dispose();
    material = {};
}
function removeGeometry(geometry) {
    geometry.dispose();
    geometry.attributes.color = {};
    geometry.attributes.normal = {};
    geometry.attributes.position = {};
    geometry.attributes.uv = {};
    geometry.attributes = {};
}
function removeTexture(texture) {
    texture.dispose();
}
